module.exports = __webpack_public_path__ + "img/zipIcon.76ec1249.svg";